import { IeServiceFormPayload } from '../models/Eserviceform.model';
import { doPost } from 'sos-eservice-common/js/services';
import { ResponseError } from 'sos-common/js/utils/ResponseError';

export function saveAnsokan(payload: IeServiceFormPayload, apiBaseRoute: string) {
  const headers = new Headers({ 'Content-Type': 'application/json' });
  //console.log(payload);

  return doPost<string>(apiBaseRoute + '/updateansokan', JSON.stringify(payload), headers).then((response) => {
    //console.log(response);
    if (response instanceof ResponseError) return response;
    return true;
  });
}
